var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('TitleComponent'),(_vm.browserIsExplorer)?_c('BrowserNotSupported'):[_c('notifications',{attrs:{"position":"top center","classes":"notification-style"}}),_c('LocaleSwitcher'),_c('Navbar'),_c('router-view'),_c('LengthChecker')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }